import { render } from "./newBillPayment.vue?vue&type=template&id=ccee7bf0"
import script from "./newBillPayment.vue?vue&type=script&lang=js"
export * from "./newBillPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__